var validation = (function (exports) {
'use strict';

var validators = {};

var parse = function (data) { return /{.+}/.test(data) ? JSON.parse(data) : { validate: data }; };

var validate = function (field) { return (
  (!field.disabled || field.dataset.validate == 'liveWithIn') && !field.hidden && field.dataset.validate &&
    validators[parse(field.dataset.validate).validate](field),
  field.validity.valid
); };

var init = function (field) {
  var data = parse(field.dataset.validate);
  var keys = Object.keys(data);
  if (keys.toString() !== 'validate') {
    keys
      .filter(function (i) { return !/validate|init/.test(i); })
      .map(function (i) { return field.addEventListener(i, validators[data[i]]); });

    data.init && validators[data.init](field);

    data.validate
      ? (field.dataset.validate = data.validate)
      : field.removeAttribute('data-validate');
  }

  return field
};

var checkElements = function (e) {
  // Validate each item in the RadioNodeList|Element
  var fields = e.target.form.elements.namedItem(e.target.name);

  fields = fields.name
    ? [fields]
    : fields;
  fields.forEach( function (itm) { return itm.checkValidity(); } );
};

var isInput = function (e) { return ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA'].includes(e.target.nodeName); };

var isRadio = function (e) { return ['checkbox', 'radio'].includes(e.target.type); };

var validstateHandler = function (e) { return isInput(e) && e.target.classList.add('touched'); };

var onfocusinHandler = function (e) { return isInput(e) && init(e.target); };

var onfocusoutHandler = function (e) {
  if(e.target.form && e.target.name){
    //check elements that are not credit card number or if credit card number has error
    if(e.target.name != 'cardnumber' || e.target.name == 'cardnumber' && e.target.dataset.validatorError){
      checkElements(e);
    }
    if(e.relatedTarget && e.relatedTarget.href){
      //user has click on a link in the form
      e.stopPropagation();

    } else {
      // Validate each item in the RadioNodeList|Element
      var fields = e.target.form.querySelectorAll('[name="'+e.target.name+'"]');
      fields = fields.name ? [fields] : fields;
      Array.from(fields).forEach( function (itm) { return itm.checkValidity(); } );
    }
  }
};

 var onblurHandler = function (e) { return e.target.form && e.target.name && e.target.name == 'cardnumber' && checkElements(e); };

var onchangeRadioHandler = function (e) { return isRadio(e) && init(e.target); };

window.addEventListener('valid', validstateHandler, true);
window.addEventListener('invalid', validstateHandler, true);
window.addEventListener('change', onchangeRadioHandler, true);
window.addEventListener('focusin', onfocusinHandler, true);
window.addEventListener('blur', onfocusoutHandler, true);
window.addEventListener('change', onfocusoutHandler, true);
window.addEventListener('input', onfocusoutHandler, true);
window.addEventListener('blur', onblurHandler, true);

var prototypes = [
  HTMLInputElement.prototype,
  HTMLSelectElement.prototype,
  HTMLButtonElement.prototype,
  HTMLTextAreaElement.prototype
];

var methods = ['checkValidity', 'reportValidity'];

var opts = { bubbles: true, cancelable: true };

prototypes.map(function (prototype) {
  methods.map(function (method) {
    var originalMethod = prototype[method];
    prototype[method] = function() {
      this.setCustomValidity('');
      var state = originalMethod.call(this) && validate(this);
      this.type !== 'hidden' &&
        (this.name || this.dataset.encryptedName) &&
        this.dispatchEvent(new Event(state ? 'valid' : 'invalid', opts));
      return state
    };
  });
});

HTMLFormElement.prototype.checkValidity = function() {
  return Array.from(this.elements)
    .map(function (i) { return i.checkValidity(); })
    .every(Boolean)
};

var onsubmitHandler = function (e) { return e.target.checkValidity() || e.preventDefault(); };

window.addEventListener('submit', onsubmitHandler, true);


// Submits the form if it has not been prevented
var defaultHandler = function (e) { return e.defaultPrevented || e.target.submit(); };

window.addEventListener('submit', defaultHandler);

var debounce = function (fn, wait) {
  if ( wait === void 0 ) wait = 100;

  var t;
  return function () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      return (clearTimeout(t), (t = setTimeout(function () { return fn.apply(void 0, args); }, wait)));
  };
};

var html = function (field) { return ("\n  <div class=\"invalidMessage flex items-center mt1" + (field.dataset.requiredCss) + "\">\n    <svg class=\"icon-24 fill-red flex-none\">\n      <use xlink:href=\"/assets/desktop/icons/icons.svg#icon-warning\"></use>\n    </svg>\n    <span class=\"error-message ms1\">" + (field.dataset.requiredMessage ||
field.validationMessage) + "</span>\n  </div>"); };

var toggleLabel = function (e) {
  // this does not apply for IE and Edge
  if(e.target.labels && e.target.labels.length){
    if(e.target.dataset.validateLegend == 'true'){
      e.target.closest('fieldset').querySelector('legend').classList.toggle('invalidMessage', e.type === 'invalid');
    } else {
      var addClass = (e.target.labels[0].dataset.noClass && e.target.labels[0].dataset.noClass == 'true') ? false : true;
      if (addClass) {
        e.target.labels[0].classList.toggle('invalidMessage', e.type === 'invalid');
      }
    }
  }
};


var errorNode = function (field) { return field.nextElementSibling
  ? field.parentNode.classList.contains('flex')
    ? field.parentNode
    : field.parentNode.lastElementChild
  : field; };


var appendOutsideNode = function (field) {
  var appendOutsideElement = field.parentNode.closest('[data-append-outside]');
  if(appendOutsideElement && appendOutsideElement.dataset.appendOutside == 'true') {
    if (appendOutsideElement.nextElementSibling) {
      appendOutsideElement.nextElementSibling.remove();
    }
    return appendOutsideElement
  }
};

var oninvalidHandler = function (e) {
  var field = e.target;
  if (field.dataset.validatorError !== 'true') {
    var appendOutsideElement = appendOutsideNode(field);
    if(appendOutsideElement){
      appendOutsideElement.insertAdjacentHTML('afterend', html(field));
    } else {
      errorNode(field).insertAdjacentHTML('afterend', html(field));
    }
    field.dataset.validatorError = true;
  }
  toggleLabel(e);
};

var scrollToFirstError = function () {
  var node = document.querySelector('[data-validator-error]');
  var scrollTop = window.pageYOffset;
  if (node) {
    // Use the HTMLInputElement label DOM element as the scroll to target if available
    node = node.labels[0] || node;

    //if spinner is visible, hide it.
    var setSpinner = document.querySelector('[data-spinner]');
    if(setSpinner){
      setSpinner.hidden = true;
    }

    // If this is a toggle then use wrapping div as the target
    var toggle = node.closest('.switch');
    if (toggle) {
      node = toggle;
    }

    if (node.offsetTop > (window.innerHeight + scrollTop)) {
      node.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  }
};

var onvalidHandler = function (e) {
  var field = e.target;
  if (field.dataset.validatorError) {
    var appendOutsideElement = appendOutsideNode(field);
    if(!appendOutsideElement){
      errorNode(field).parentNode.querySelector('.invalidMessage:not(label)').remove();
    }
    field.removeAttribute('data-validator-error');
  }
  toggleLabel(e);
};

window.addEventListener('valid', onvalidHandler);
window.addEventListener('invalid', oninvalidHandler);
window.addEventListener('invalid', debounce(scrollToFirstError, 100));

validators.childrenyoungest = function (field) {
  if (field.id === 'childrenNumber') {
    var youngest = field.form.querySelector('[name=childrenYoungest]');
    youngest.disabled = (Number(field.value) >= 2) ? false : true;
    //set disabled field back to default state
    if (youngest.disabled && youngest.type.includes('select')) {
      youngest.selectedIndex = 0;
      youngest.dispatchEvent(new Event('change', {'bubbles': true}));
    }

    // childrenOldest - disable if number of children is 0
    var oldest = field.form.querySelector('[name=childrenOldest]');
    oldest.disabled = (Number(field.value) >= 1) ? false : true;
    //set disabled field back to default state
    if (oldest.disabled && oldest.type.includes('select')) {
      oldest.selectedIndex = 0;
      oldest.dispatchEvent(new Event('change', {'bubbles': true}));
    }
  }
  if (field.id === 'childrenNumber_w') {
    var youngestWant = field.form.querySelector('[name=childrenYoungest_w]');
    youngestWant.disabled = (Number(field.value) >= 2) ? false : true;
    //set disabled field back to default state
    if (youngestWant.disabled && youngestWant.type.includes('select')) {
      youngestWant.selectedIndex = 0;
      youngestWant.dispatchEvent(new Event('change', {'bubbles': true}));
    }
    // childrenOldest - disable if number of children is 0
    var oldestWant = field.form.querySelector('[name=childrenOldest_w]');
    oldestWant.disabled = (Number(field.value) >= 1) ? false : true;
    //set disabled field back to default state
    if (oldestWant.disabled && oldestWant.type.includes('select')) {
      oldestWant.selectedIndex = 0;
      oldestWant.dispatchEvent(new Event('change', {'bubbles': true}));
    }
  }
};

validators.expirymonth = function (field) {
  var year = field.form.querySelector('[data-validate="expiryyear"]');

  if(year){
    var yyv = year.value;
    var dd = new Date().toISOString();
    var yy = dd.substr(2, 2);

    if(yyv.length == 4){
      //worldpay year value is four digits
      yy = new Date().getFullYear();
    } else {
      yy = dd.substr(2, 2);
    }
    var mm = dd.substr(5, 2);

    year.setCustomValidity(
      year.selectedIndex === 0 ||
      (yyv == yy && field.value >= mm) ||
      (yyv > yy && field.selectedIndex)
        ? ''
        : field.dataset.requiredMessage
    );
  }
};

validators.expiryyear = function (field) { return field.form.querySelector('[data-validate="expirymonth"]').checkValidity(); };

var luhn = (function (arr) {
  return function (value) {
    var len = value.length,
      bit = 1,
      sum = 0,
      val;

    while (len) {
      val = parseInt(value.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0
  }
})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

validators.creditcardnumber = function (field) {

  var numberValid = false;

  //remove any white spaces or dashes from value
  var ccNumber = field.value.replace(/[^\d]/g, '');

  //pattern check, first digit can only start with a number between 2-9.
  // card number must be between 12 and 19 digits long
  if(/^[1-9]{1}[0-9]{12,19}/.test(ccNumber)){
    // if luhn fails, set field to invalid
    numberValid = luhn(ccNumber.replace(/[^\d]/g, ''))? true : false;
  }

  field.setCustomValidity(numberValid ? '' : field.dataset.requiredMessage);
};

var excludes = [
  'upgrade'
];

/* eslint-env browser */

var storage = require('../../storage');

var notice;
var defaultmsg = '';
var defaultMsgMeta = document.getElementById('defaultmessage');
if (defaultMsgMeta) {
  defaultmsg = defaultMsgMeta.content;
}
var store = [];
var notices = document.getElementById('notices');
var warn = function (msg) { return queue(("<p class=\"m0 p1 bg-red white\">" + (msg || defaultmsg) + "</p>"), true); };
var queue = function (data, prepend) { return (
  store[ prepend ? 'unshift' : 'push' ](data), notice || dequeue()
); };

var dequeue = function () { return (
  (notice = store.shift()), notice && set(notice).then(dequeue)
); };

var set = function (notice) { return new Promise(function (resolve, reject) { return show(resolve, reject, notice); }); };

var show = function (resolve, reject, notice) {
  notices.innerHTML = notice;
  document.documentElement.classList.add('notices-open');
  var duration = /icon/.test(notice) ? 6000 : 4000;
  setTimeout(hide, duration, resolve, reject, notice);
};

var hide = function (resolve, reject, notice) {
  document.documentElement.classList.remove('notices-open');
  wait(resolve);
};

var exclude = function () { return excludes.some(function (i) { return location.pathname.includes(i); }); };
var wait = function (resolve) { return setTimeout(exclude() ? wait : resolve, 500); };

var remove = function (e) {
  var current = e.target.closest('[data-notice-close]');
  if(current){
    storage.setStorage('cm-search-notice', 'hide', 'data-notice-remove');
    findNotice(false);
  }
};

var findNotice = function (show) {
  var target = document.querySelector('[data-notice-remove]');
  if(target && !show){
    target.remove();
  } else if (target && show){
    target.classList.remove('hide');
    target.classList.add('slide-in-bottom');
  }
};

var checkNoticeSetting = function () {
  if(storage.hasStorage()){
    if(!storage.getStorage('cm-search-notice')){
      findNotice(true);
    }
  }
};

document.addEventListener('click', remove);
document.addEventListener('DOMContentLoaded', checkNoticeSetting);

validators.emailavailable = function (field) {
  field.setCustomValidity(
    'emailUsed' in field.dataset &&
    field.dataset.emailUsed === 'used'
      ? field.requiredMessage
      : ''
  );
};

var onfocusinHandler$1 = function (e) {
  var field = e.target;
  if (field && field.type == 'email' && field.dataset.validate && field.dataset.validate === 'emailavailable' && field.dataset.emailUsed && field.dataset.emailUsed === 'used') {
    // Reset state of email available validation
    field.dataset.emailUsed = 'check';
    field.dataset.emailUsedEmail = '';

    // Set back to default validation
    field.requiredMessage = field.dataset.defaultError || field.requiredMessage;
    field.dispatchEvent(new Event(field.checkValidity() ? 'valid' : 'invalid',  { bubbles: true, cancelable: true }));
  }
};

var onsubmitHandler$1 = function (e) {
  var form = e.target;
  var field =
  form.querySelector('[data-validate=emailavailable]');
  //show spinner overlay, while we wait
  var setSpinner = form.querySelector('[data-spinner]');
  if(setSpinner && field.checkValidity()){
    setSpinner.hidden = false;
  }

  // Store the default error message (which is in the field data-required-message)
  if (field && !('defaultError' in field.dataset)) {
    field.dataset.defaultError = field.dataset.requiredMessage;
  }
  if (field && field.dataset.emailUsed && field.dataset.emailUsed === 'used' && field.dataset.emailUsedEmail === field.value) {
    // Email have been checked but there is no change and remains invalid
    e.preventDefault();
    //hide spinner again
    if(setSpinner){
      setSpinner.hidden = true;
    }

  } else if (field && (!field.dataset.emailUsed || field.dataset.emailUsedEmail !== field.value)) {
    // Email has not be validated as 'not used'
    e.preventDefault();

    field.dataset.emailUsedEmail = field.value;
    field.dataset.emailUsed = 'checking';

    var formData = new FormData();
    formData.append('email', field.value);

    fetch(field.formAction, {
      method: 'POST',
      body: formData
    })
      .then(function (res) { return res.json(); })
      .then(
        function (res) {
          field.dataset.emailUsed = res.status ? 'used' : 'notused';
          //show / hide spinner again
          if(setSpinner){
            setSpinner.hidden = true; 
          }
          return (field.dataset.requiredMessage = res.message ? res.message : field.dataset.defaultError)
        }
      )
      .then(function () { return form.dispatchEvent(
          new Event('submit', { bubbles: true, cancelable: true })
        ); }
      )
      .catch(warn);
  }
};

window.addEventListener('submit', onsubmitHandler$1, true);
window.addEventListener('focusin', onfocusinHandler$1, true);

validators.equalvalue = function (field) {
  var target = field.form.querySelector('[name='+field.dataset.equalvalue+']');
  field.setCustomValidity(target.value === field.value ? '' : field.dataset.requiredMessage);
};

var opts$1 = {
  bubbles: true,
  cancelable: true
};

var setValidity = function (field, valid, msg) {
  field.setCustomValidity(msg);
  field.dispatchEvent(new Event(valid ? 'valid' : 'invalid', opts$1));
};

validators.requireone = function (field) {
  var fields = field.form.querySelectorAll('[name='+field.name+']');
  fields = Array.from(fields);
  var valid = Boolean(fields.filter(function (i) { return i.checked; }).length);
  var appendOutside = '';
  var msg = valid
    ? ''
    : field.parentNode.closest('[data-validate-requireone]').dataset.validateRequireone;
  fields.map(function (field) { return setValidity(field, valid, msg); });
};

validators.nowhitespace = function (field) {
  field.setCustomValidity((field.value.length > 0 &&  field.value.trim().length === 0) ? field.dataset.requiredMessage : '');
};

validators.selectdate = function (field) {
  var target = field.closest('[data-valid-selectdate=group]');
  if (target && field.value != '') {
    var elements = target.querySelectorAll('[data-valid-selectdate]');
    var fields = [];
    Array.from(elements).filter(function (element) {
        if(element && /^(y|m|d)$/.test(element.dataset.validSelectdate) && element.value != ''){
          fields.push(element);
        }
      }
    );
    // only check date when we have all the values
    if(fields.length == elements.length){
      var date = 'y-m-d';
      Array.from(fields).forEach(
        function(field){
          var fieldValue = field.value.length === 1 ? '0' + field.value : field.value;
          date = date.replace(field.dataset.validSelectdate, fieldValue);
        }
      );

      var complete = date.length === 10;

      var valid =
        complete && date === new Date(date).toISOString().substr(0, 10);

      var errorField = fields.pop();

      if (!valid && field === errorField) {
        var title = errorField.title;
        errorField.title = target.title;
        requestAnimationFrame(function () { return (errorField.title = title); });
      }

      if (complete && field !== errorField) {
        errorField.dispatchEvent(
          new Event('change', { bubbles: true, cancelable: true })
        );
      }

      errorField.setCustomValidity(valid ? '' : errorField.title);
    }
  }
};

validators.nospecialcharacters = function (field) {
  // RegExp Unicode property escapes
  var regex = '';
  if(field.dataset.validateShortlist && field.dataset.validateShortlist == 'true'){
    //short list is only used for First name during registration
    regex = /[0-9@#%$&()+=<>{}\[\]\\\/]+/gi;
  } else {
    regex = /[!@#$%^^*()///&'`~\\\[\]\-{}_+=|\":;><?,.]+/gi;
  }
  field.value=field.value.replace(regex,'');
};

validators.liveWithIn = function (field) {
    if (field.name === 'cityLive' || 'cityLive_w') {
      var elementName = (field.name === 'cityLive')? '[name=livingWithinRadius]' : '[name=livingWithinRadius_w]';
      var element = field.form.querySelector(elementName);
      if (element) {
        var hideWrapper = element.closest('[data-livingWithIn-hide]');
        // if disabled, reset livingWithInRAdius to data-reset-value or Any.
        if (Number(field.value) < 0) {
          element.selectedIndex = findIndex(element, element.dataset.resetValue);
          if (hideWrapper) {
            hideWrapper.classList.add('hide');
          }
        } else {
          if (hideWrapper) {
            hideWrapper.classList.remove('hide');
          }
        }
        element.disabled = (Number(field.value) < 0) ? true : false;
      }
  }
};

function findIndex(element, valueToFind) {
  var index = 0;
  for (var i = 0; i < element.options.length; i++) {
    if (element.options[i].value === valueToFind) {
      index = i;
    }
  }
  return index; // Return the index of the found value
}

var config = require('../../config').config;

function validateFiscalNumber(fiscalNumber) {
    return new Promise(function (resolve, reject) {
        var countryValue = Number(document.querySelector('[data-fiscal-bind]').value);
        var ebanxIsValid = false;

        // List of supported country values ('Argentina','Bolivia','Brazil','Chile','Colombia','Ecuador','Mexico','Peru','Uruguay'). Please see supported countries set in model\layout\act_getChatVariables.cfm
        var supportedCountries = Array.from(config.fiscalNumberSupportedCountries);

        // Check if the countryValue is not in the supported list
        if (!supportedCountries.includes(countryValue)) {
            resolve(true); // Return true to indicate no further validation needed
            return
        }

        // Map of country values to document types
        var documentTypeMap = {
            12: { // Argentina
                CDI: 'ar_cdi',
                CUIL: 'ar_cuil',
                CUIT: 'ar_cuit',
                DNI: 'ar_dni'
            },
            30: { // Brazil
                CPF: 'br_cpf',
                CNPJ: 'br_cnpj'
            },
            43: { // Chile
                RUT: 'cl_rut'
            },
            48: { // Colombia
                CC: 'co_cc',
                CE: 'co_ce',
                NIT: 'co_nit'
            },
            60: { // Ecuador
                DOC: 'ec_doc'
            },
            168: { // Peru
                DOC: 'pe_doc'
            },
            225: { // Uruguay
                CI: 'uy_ci'
            }
        };

        // Get the dropdown element and check if it exists
        var documentType = document.querySelector('[data-document-type-bind]').value;

        // Get the document type parameter value
        var typeParam = documentTypeMap[countryValue][documentType];

        // If document type is not found for the given country, return true
        if (!typeParam) {
            resolve(true); // Return true if document type is not supported
            return
        }

        EBANX.init({
            publicIntegrationKey: 'live_pk_PXQJHEQ-9UzCXBZC0awzOw',
            country: 'br',
            mode: 'production'
        });

        var docInformation = {
            type: typeParam,
            document: fiscalNumber
        };

        EBANX.utils.document.check(docInformation)
            .then(function(verificationData) {
                ebanxIsValid = verificationData.data.document.isValid;
                resolve(ebanxIsValid); // Call the resolve function with the validation result
            })
            .catch(function(error) {
                //console.error('Validation failed:', error);
                resolve(true); // Return true for error. We do not want the payment to be stuck in case sdk fails
            });
    })
}

// Use event to trigger validation result as the lag in async sdk call is causing event to be missed
function dispatchEbanx(field, ebanxIsValid) {
    var opts = { bubbles: true, cancelable: true };
    field.dispatchEvent(new Event(ebanxIsValid ? 'valid' : 'invalid', opts));

}

function setCustomFieldValidation(field, ebanxIsValid) {
    var message = field.dataset.requiredMessage;
    if (ebanxIsValid) {
        message = '';
    }
    field.setCustomValidity(message);
    dispatchEbanx(field, ebanxIsValid);

    setCustomDataAttribute(field, ebanxIsValid);

}

// function used to set a custom attribute that will allow us to bypass the delayed validation when data is valid and vice versa
function setCustomDataAttribute(field, ebanxIsValid) {
    field.setAttribute('data-fiscal-isvalid', ebanxIsValid);
}


validators.fiscalnumber = function(field) {

    // If field is disabled (hidden for unsupported countries) skip validation
    if (field.disabled) {
        return;
    }

    // if any change in the data in the input field, then reset the custom attribute
    field.addEventListener('change', function() { setCustomDataAttribute(field, false); });

    // when document type is changed then make the document field empty
    var documentType = document.querySelector('[data-document-type-bind]');

    if (documentType) {
        documentType.addEventListener('change', function() { field.value = ''; });
    }

    // skip the validation is no change made and already validated
    if (field.dataset.fiscalIsvalid == 'true') {
        return
    }

    // only validate if longer than 3 chars
    if (field.value.length < 3) {
        setCustomFieldValidation(field, false);
        return
    }

    setCustomFieldValidation(field, false);

    // Remove any white spaces or dashes from value
    var fiscalNumber = field.value.replace(/[^\d]/g, '');

    // Call validateFiscalNumber, which returns a Promise
    validateFiscalNumber(fiscalNumber).then(function(ebanxIsValid) {

        // Set the custom validity based on the result
        setCustomFieldValidation(field, ebanxIsValid);

    }).catch(function(error) {
        console.error('Error in fiscal number validation:', error);
            // We do not want the payment to be stuck in case sdk fails
        setCustomFieldValidation(field, true);

    });
};

exports.validators = validators;

return exports;

}({}));
//# sourceMappingURL=formvalidation.js.map
